import { useAuthInfo } from '@propelauth/react';

function useRequiredAuthInfo() {
  const auth = useAuthInfo();

  if (auth.loading || !auth.isLoggedIn) {
    throw new Error('useRequiredAuthInfo used outside authenticated context');
  }

  return auth;
}

export default useRequiredAuthInfo;